export default __webpack_public_path__ + "static/media/filling_4.49d4a1e2.jpg";